export const getInitialState = (): any => ({
  predictionProgressData: {},
  predictionProgressStatus: 0
});
